<template>
  <div class="list-area">
    <el-row :gutter="6">
      <el-col :span="6">
        <el-row type="flex" align="middle">
          <span style="white-space: nowrap"> 日期：</span>
          <el-date-picker
            size="small"
            type="daterange"
            range-separator="至"
            v-model="searchData.date"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-row>
      </el-col>
      <el-col :span="5">
        <el-input
          size="small"
          placeholder="请输入搜索内容"
          v-model.trim="serachKeyword"
          class="input-with-select"
        >
          <el-select
            size="small"
            slot="prepend"
            v-model="serachKeywordCode"
            placeholder="请选择类型"
            style="width: 120px"
          >
            <el-option label="应用名称" value="apkname"></el-option>
            <el-option label="应用包名" value="packageName"></el-option>
          </el-select>
        </el-input>
      </el-col>
      <el-col :span="3">
        <el-select
          v-model="searchData.countryCode"
          placeholder="国家/地区"
          clearable
          filterable
        >
          <el-option
            v-for="item in countryList"
            :key="item.countryCode"
            :label="item.countryName"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" align="middle">
          <span style="white-space: nowrap"> 商务：</span>
          <el-select
            v-model="searchData.businesser"
            placeholder="商务"
            clearable
            filterable
          >
            <el-option
              v-for="item in businessNameList"
              :key="item.id"
              :value="item.name"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-row>
      </el-col>
      <el-col :span="4">
        <el-row type="flex" align="middle">
          <span style="white-space: nowrap"> 开发者：</span>
          <el-select
            v-model="searchData.developer"
            placeholder="开发者"
            clearable
            filterable
            @change="changeDeveloper"
          >
            <el-option
              v-for="item in CompanyNameList"
              :key="item.id"
              :label="`${item.developerName}`"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-row>
      </el-col>
    </el-row>

    <el-form :inline="true" label-suffix=":">
      <el-form-item label="客户号" class="demo-form-inline headLabel">
        <el-select
          v-model="searchData.rofcusno"
          size="small"
          placeholder="请选择客户号"
          clearable
          filterable
        >
          <el-option
            :label="item"
            :value="item"
            v-for="item in custormList"
            :key="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="渠道号" class="demo-form-inline headLabel">
        <el-select
          v-model="searchData.rofchno"
          size="small"
          placeholder="请选择渠道号"
          clearable
          filterable
        >
          <el-option
            :label="item"
            :value="item"
            v-for="item in channelList"
            :key="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目号" class="demo-form-inline headLabel">
        <el-select
          v-model="searchData.rofcusbr"
          size="small"
          placeholder="请选择项目号"
          clearable
          filterable
        >
          <el-option
            :label="item"
            :value="item"
            v-for="item in rofcusbrList"
            :key="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推广位" class="demo-form-inline headLabel">
        <el-select
          v-model="searchData.promotionPos"
          size="small"
          placeholder="请选择推广位"
          clearable
          filterable
          multiple
        >
          <el-option
            :label="item.value"
            :value="item.key"
            v-for="item in promotionTypes"
            :key="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="getTableList()">
          查询
        </el-button>
        <ExportTable class="ml10" @download="getDownloadList"></ExportTable>
      </el-form-item>
    </el-form>
    <PageTable
      :columns="columns"
      :tableData="tableData"
      @page-change="handleChangePage"
    >
      <template slot-scope="{ row }" slot="promotionPos">{{
        row.promotionPos | typeDesc(promotionTypes)
      }}</template>
    </PageTable>
  </div>
</template>
<script>
import PageTable from "@/components/PageTableSort.vue";
import ExportTable from "@/components/ExportTable.vue";
import {
  getCategoryList,
  getDownloadSource,
  getBusinessManagerList,
  getDeveloperUserList,
  getDeveloperList,
} from "./indexServe";
import { cmsCountryAll } from "@/common/js/api";
import {
  MAXSIZEDOWN,
  MAXSIZE,
  promotionTypes,
} from "@/common/constant/constant";

import moment from "moment";
let end = moment(new Date()).format("YYYY-MM-DD");
let start = new Date();
start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
start = moment(start).format("YYYY-MM-DD");

export default {
  name: "terminalReport",
  components: { ExportTable, PageTable },
  created() {
    this.fetchCountryList();
    this.fetchCustomList();
    this.getBusinessManagerList();
    this.getDeveloperList();
    this.init();
  },
  data() {
    return {
      promotionTypes,
      countryList: [],
      custormList: [], //客户号
      channelList: [], //渠道
      rofcusbrList: [], //项目号
      promotionList: [
        {
          value: "01",
          label: "云文件夹-桌面-icon",
        },
        {
          value: "02",
          label: "正方形运营位大图-智慧助手-正方形图片",
        },
        {
          value: "03",
          label: "正方形运营位ICON-智慧助手-icon",
        },
        {
          value: "04",
          label: "全局搜索前-常用应用NO.4-icon",
        },
        {
          value: "05",
          label: "右一屏-常用应用NO.2-icon",
        },
        {
          value: "06",
          label: "开机向导-OOBE-icon",
        },
      ],
      serachKeyword: "",
      serachKeywordCode: "apkname",

      searchData: {
        date: [start, end],
      },
      tableData: {
        list: [],
      },
      columns: [
        {
          key: "pt",
          label: "日期",
          align: "center",
        },
        {
          key: "apkName",
          label: "应用名称",
          align: "center",
        },
        {
          key: "packageName",
          label: "包名",
          align: "center",
        },
        {
          key: "countryName",
          label: "国家/地区",
          align: "center",
        },
        {
          key: "rofcusno",
          label: "客户号",
          align: "center",
        },
        {
          key: "rofchno",
          label: "渠道号",
          align: "center",
        },
        {
          key: "rofcusbr",
          label: "项目号",
          align: "center",
        },
        {
          slot: "promotionPos",
          label: "推广位",
          align: "center",
        },
        {
          key: "showPv",
          label: "曝光",
          align: "center",
        },
        {
          key: "clickPv",
          label: "点击",
          align: "center",
        },
        {
          key: "clickRate",
          label: "点击率",
          align: "center",
        },
      ],
      visible: false, //控制drawer的显示和隐藏
      operationType: "", // 记录当前操作模式新建-create、编辑-edit
      detailData: {},
      businessNameList: [],
      CompanyNameList: [],
      newsTableData: [],
    };
  },

  methods: {
    changeDeveloper(e) {
      if (e == "") {
        this.searchData.developer = null;
      }
    },
    // 获取开发者列表
    async getDeveloperList() {
      const data = {
        page: 1,
        size: 9999,
      };
      const res = await getDeveloperUserList(data);
      if (res) {
        this.CompanyNameList = res.data.list;
      }
    },
    // 获取商务管理人员
    async getBusinessManagerList() {
      const res = await getBusinessManagerList({
        page: 1,
        size: MAXSIZE,
      });
      if (res && res.code === 0) {
        this.businessNameList = res.data.list;
      }
    },
    // 获取渠道号、项目号、客户号
    async fetchCustomList() {
      const res = await getDownloadSource({
        size: 1000,
        page: 1,
      });

      this.custormList = res.data.custormList;
      this.channelList = res.data.channelList;
      this.rofcusbrList = res.data.rofcusbrList;
    },
    // 获取国家地区列表
    async fetchCountryList() {
      const res = await cmsCountryAll();
      this.countryList = [].concat(res.data);
    },
    // 事件监听
    handleChangePage({ page, size }) {
      this.searchData.page = page;
      this.searchData.size = size;
      this.getTableList();
      // const newsTableList = this.newsTableData;
      // this.tableData.page = page;
      // this.tableData.size = size;
      // const startIndex = (this.tableData.page - 1) * this.tableData.size;
      // const endIndex = startIndex + Number(this.tableData.size);
      // this.tableData.list = newsTableList.list.slice(startIndex, endIndex);
      // this.tableData.total = newsTableList.total;
      // console.log(this.tableData, page, size, "切换页码");
      // this.getTableList({ page, size });
    },
    handleOperate(operationType, row) {
      this.operationType = operationType;
      this.visible = true;
      if (operationType === "create") {
        this.detailData = {};
      }
    },
    typeDesc(key, list = []) {
      return (list.find((item) => item.key == key) || {}).value || key;
    },
    // 后端请求
    async getDownloadList(callback) {
      const res = await this.getTableList({ page: 1, size: MAXSIZEDOWN }, true);
      if (res) {
        const headerDisplay = {};
        this.columns.forEach((item) => {
          const key = item.key || item.slot;
          if (key !== "action") {
            headerDisplay[key] = item.label;
          }
        });

        if (res.list && res.list.length > 0) {
          res.list.forEach((item) => {
            if (item.promotionPos) {
              this.promotionTypes.forEach((item1) => {
                if (item1.key == item.promotionPos) {
                  item.promotionPos = item1.value;
                }
              });
            }
          });
        }
        const list = res.list;
        callback({
          fileName: "桌面推广报表-GP",
          headerDisplay,
          list,
        });
      }
    },
    // 获取列表
    async getTableList(params, isDownload) {
      const obj = {
        page: 1,
        size: 10,
        ...this.searchData,
        ...params,
      };
      if (obj.date && obj.date.length > 0) {
        obj.startTime = obj.date[0];
        obj.endTime = obj.date[1];
      }
      if (this.serachKeyword) obj[this.serachKeywordCode] = this.serachKeyword;

      const res = await getCategoryList(obj);
      if (res && res.code === 0) {
        // 下载时，不需要更新到table
        if (!isDownload) {
          this.tableData = res.data;
        }
        return res.data;
      }
    },

    // 其他
    init() {
      this.getTableList();
    },
  },
};
</script>
<style scoped lang="scss">
.list-area {
  position: relative;
  .page-foot {
    display: inline-block;
    position: absolute;
    margin-top: -30px;
    div {
      margin-right: 5px;
    }
  }
}
</style>
